<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('setting.setting')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="cell-card">
      <div class="cell-row" @click="toInfomation()">
        <div class="left">{{ $t("setting.base_setting") }}</div>
        <van-icon name="arrow" color="#c8c9cc" />
      </div>
      <div class="cell-row" @click="toLoginPassword()">
        <div class="left">{{ $t("setting.login_pwd") }}</div>
        <van-icon name="arrow" color="#c8c9cc" />
      </div>
      <div class="cell-row" @click="toPayPassword()">
        <div class="left">{{ $t("setting.finance_pwd") }}</div>
        <div class="right">
          <span class="desc">{{ userInfo.paypassword }}</span>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
      </div>
      <div class="cell-row" @click="toLanguage()">
        <div class="left">{{ $t("setting.language") }}</div>
        <van-icon name="arrow" color="#c8c9cc" />
      </div>
    </div>

    <van-button class="sign-out" type="primary" @click="loginout()">
      {{ $t("setting.logout") }}
    </van-button>
  </div>
</template>

<script>
export default {
  data() {
    return { userInfo: {} };
  },
  methods: {
    back() {
      return window.history.back();
    },
    toPayPassword() {
      if (this.userInfo.paypassword !== this.$t("setting.no_setting")) {
        this.$toast(this.$t("withdraw.with_service"));
      } else {
        this.$router.push({ path: "/SetPayPassword" });
      }
    },
    toLoginPassword() {
      this.$router.push({ path: "/SetLoginPassword" });
    },
    toLanguage() {
      this.$router.push({ name: "Language", params: { type: "setting" } });
    },
    toInfomation() {
      this.$router.push({ path: "/Infomation" });
    },
    loginout() {
      localStorage.clear();
      this.$router.push({ path: "/Mine" });
    },
    getUserInfo() {
      this.$http({ method: "get", url: "user_info" }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.userInfo.paypassword = res.data.paypassword
            ? this.$t("setting.y_setting")
            : this.$t("setting.no_setting");
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="less" scoped>
.sub-page {
  min-height: 100vh;
  background: #000000;
  padding-bottom: 40px;
}
.cell-card {
  background: #141414;
  border-radius: 16px;
  margin: 24px;
  overflow: hidden;
}
.cell-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 34px 28px;
  border-bottom: 1px solid rgba(201,168,76,0.2);
  font-size: 30px;
  color: #c9a84c;
  &:last-child {
    border-bottom: none;
  }
  .right {
    display: flex;
    align-items: center;
  }
  .desc {
    margin-right: 10px;
    color: #979799;
    font-size: 28px;
  }
}
.sign-out {
  display: block;
  width: calc(100% - 48px);
  margin: 80px 24px 0;
  height: 90px !important;
  line-height: 90px;
  border-radius: 45px !important;
  border: none !important;
  background: #c9a84c !important;
  color: #000 !important;
  font-size: 32px !important;
  font-weight: 700;
}
</style>
